<script setup lang="ts">
import MallEstimationPage from "~/components/user-center-estimation/MallEstimationPage.vue";

definePageMeta({
  layout: false,
  ssr: false,
});
</script>

<template>
  <MallEstimationPage />
</template>
